export default __webpack_public_path__ + "static/media/maintenance.facfded7.svg";